import { SupplyAgoraV1DiscountedOfferService } from '@skyscanner-internal/agora-web-http-client';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';

import type { SupplyAgoraV1DiscountedOffer } from '@skyscanner-internal/agora-web-http-client';

type FetchRequest = SupplyAgoraV1DiscountedOffer.FetchRequest;
type FetchResponse = SupplyAgoraV1DiscountedOffer.FetchResponse;

const LOYALTY_DISCOUNTS_CLIENT_NAME = 'LOYALTY_DISCOUNTS';

export const loyaltyDiscountsRequest = grpcFetchClientWrapper<FetchRequest, FetchResponse>(
  SupplyAgoraV1DiscountedOfferService.DiscountedOfferService.FetchDiscountInfoList,
  {
    clientName: LOYALTY_DISCOUNTS_CLIENT_NAME,
    pathPrefix: '/g/agora',
  },
);
